<template>
    <Layout>
        <div style="display: flex;justify-content: center;padding:50px 0;align-items: center;width: 100%;">
            <div style="width:80%;" v-if="login_status === -1">

                <!-- 登录 -->
                <p style="text-align:center;padding:10px 0;">{{$t("common.no_login")}}</p>

                <div style="padding:30px 0px;">
                    <router-link :to="{ name: 'login' }">
                        <el-button type="warning" size="medium" style="width:100%;">
                            {{$t("button.login")}}
                        </el-button>
                    </router-link>
                </div>

            </div>

            <div style="width:80%;" v-if="login_status === 1">

                <!-- 登录 -->
                <div>
                    <p v-if="config.LOGIN_TYPE === 'tel'" style="text-align: center;font-size: 30px;color: #e7a23b;">
                        {{login_data.tel_num}}
                    </p>
                    <p v-if="config.LOGIN_TYPE === 'mail'" style="text-align: center;font-size: 30px;color: #e7a23b;">
                        {{login_data.mail}}
                    </p>
                </div>
                <div style="margin-top:20px;">
                    <el-form ref="form" label-width="100px">
                        <el-form-item :label="$t('deng-lu-er-ci-yan-zheng')">
                            <el-radio-group v-model="login_data.verify_status"  type="success" size="mini" @change="verifyStatusChange(login_data.verify_status)">
                                <el-radio-button
                                    v-for="options in [
                                        {
                                            value: -1,
                                            title: $t('guan-bi')
                                        }, {
                                            value: 2,
                                            title: $t('zhi-neng')
                                        }, {
                                            value: 1,
                                            title: $t('kai-qi')
                                        }
                                    ]"
                                    :key="options.value"
                                    :label="options.value"
                                >{{ options.title }}</el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item style="text-align: left;">
                            <p>{{ $t('guan-bi') }}: {{ $t('bu-hui-dan-chu-er-ci-deng-lu-yan-zheng') }}</p>
                            <p>{{ $t('zhi-neng') }}: {{ $t('gen-ju-dang-qian-xi-tong-huan-jing-dan-chu-er-ci-deng-lu-yan-zheng') }}</p>
                            <p>{{ $t('kai-qi') }}: {{ $t('mei-ci-deng-lu-du-hui-dan-chu-er-ci-deng-lu-yan-zheng') }}</p>
                        </el-form-item>
                    </el-form>
                </div>

            </div>
        </div>
        <!-- breadcrumb-area-end -->
    </Layout>
</template>

<script>
import Cookies from 'js-cookie'
import { updateVerify, getUserInfo } from '@/api/user'
import Layout from '@/components/Layout.vue'
import config from '@/config/config.js'
import { InitCorpDetail } from '@/utils/pri'
export default {
    components: { Layout },
    name: 'Verify',
    computed: {

    },
    data () {
        return {
            VUE_APP_PROJECT: process.env.VUE_APP_PROJECT,
            VUE_APP_PRODUCT: process.env.VUE_APP_PRODUCT,
            // 登录数据
            login_data: {
                tel_num: '',
                mail: '',
                verify_status: 0
            },
            login_status: 0,
            config
        }
    },
    async mounted () {
        if (process.env.VUE_APP_PRODUCT === 'cuiqiu_domain_pri') {
            try {
                await InitCorpDetail()
            } catch (err) {
                this.$message({ message: err, type: 'error' })
            }
        }
        this.initUserInfo()
    },
    methods: {
        async verifyStatusChange (verify_status) {
            if (verify_status === -1) {
                this.$message.error(this.$t('fang-zhi-nin-de-zhang-hao-bei-bie-ren-dao-yong-er-ci-yan-zheng-bu-zhi-chi-zi-zhu-guan-bi-ru-xu-guan-bi-qing-lian-xi-ke-fu-shou-dong-guan-bi'))
                return
            }

            try {
                await updateVerify({
                    verify_status
                })
                this.initUserInfo()
                this.$message.success(this.$t('message.update_success'))
            } catch (err) {
                this.initUserInfo()
                console.error('updateVerify Err', err)
                this.$message.error(err || this.$t('message.update_fail'))
            }
        },
        async initUserInfo () {
            const token = Cookies.get(config.COOKIES.TOKEN)
            if (!token) {
                this.login_status = -1
                return
            }
            this.token = Cookies.get(config.COOKIES.TOKEN)
            try {
                const userResponse = await getUserInfo({})
                const { user = '' } = userResponse.data || {}
                const { tel_num = '', mail = '', status = 0, verify_status = 0 } = user
                if (status === 1) {
                    this.login_data.tel_num = tel_num
                    this.login_data.mail = mail
                    this.login_data.verify_status = verify_status
                    this.login_status = 1
                } else {
                    this.login_status = -1
                }
            } catch (err) {
                console.error('getUserInfo Err', err)
                this.$message.error(err || this.$t('wu-fa-huo-qu-yong-hu-xin-xi'))
            }
        }
    }
}
</script>

<style scoped>

</style>
